import { render, staticRenderFns } from "./SfaultType.vue?vue&type=template&id=d0a74d30&"
import script from "./SfaultType.vue?vue&type=script&lang=ts&"
export * from "./SfaultType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports